import { LazyLoad } from '@petconsole/pure-fe-mui';

const GroomerAdmin = LazyLoad(() => import('./GroomerAdmin'));

export { GroomerAdmin };
